import { Component, OnInit } from '@angular/core';
import { AnreService } from '../service/anre.service';
import { Router } from '@angular/router';
import { TaskFilterForm } from '../../shared/models/TaskFilterForm';
import { Page } from '../../../shared/model/page';
import { Task } from '../../account/models/Task';

@Component({
  selector: 'app-task-anre',
  templateUrl: './task-anre.component.html',
  styleUrls: ['./task-anre.component.scss']
})
export class TaskAnreComponent implements OnInit {

  public tasks: Page<Task>;
  public paginationTasks = [];
  public taskFilterForm: TaskFilterForm = new TaskFilterForm();
  public taskDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'takeTask',
          title: '<p class="actionRT">Rezolva task</p>'
        },
        {
          name: 'viewDetails',
          title: '<p>Vezi detalii</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row: any) => {

      if (row.data.status == 'FINALIZED') {
        return 'row_finalized';
      } else {
        return '';
      }
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      number: {
        title: 'Numar'
      },
      task: {
        title: 'Task'
      },
      companyName: {
        title: 'Nume Companie'
      },
      companyCode: {
        title: 'CUI Companie'
      },
      taskDate: {
        title: 'Data primire',
        valuePrepareFunction: (value: any) => { return value ? new Date(value).toLocaleDateString("ro-RO") : '' }
      },
      status: {
        title: 'Status',
        //         valuePrepareFunction: (value) => { return value ? 'Atribuit' : 'Neatribuit' }
      },
      statusDate: {
        title: 'Data status',
        valuePrepareFunction: (value: any) => { return value ? new Date(value).toLocaleDateString("ro-RO") : '' }
      },
      assignee: {
        title: 'Responsabil alocat',
        valuePrepareFunction: (value: any) => { return 'ANRE' }
        //         valuePrepareFunction: (value) => { return value ? value : '-' }
      },
    },
  };

  constructor(
    private anreService: AnreService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.updateTaskList();
  }

  private updateTaskList(): void {
    this.taskFilterForm.status = 'ASSIGNED';
    this.searchTasks(this.taskFilterForm.status);
  }

  onCustomActionTasks(event: any): void {
    switch (event.action) {
      case 'takeTask': {
        this.anreService.assignAnreTask(event.data.number).subscribe(() => {
          this.router.navigateByUrl('/anre/task-validare',
            { state: { taskId: event.data.number, editable: true } });
        });
        break;
      }
      case 'viewDetails': {
        this.router.navigateByUrl('/anre/task-validare',
          { state: { taskId: event.data.number, editable: false } });
      }
    }
  }

  searchTasks(status: string, offset?: number): void {
    this.taskFilterForm.pageOffset = offset;
    this.taskFilterForm.status = status;
    this.anreService.getAnreTasks(this.taskFilterForm).subscribe((val) => {
      this.tasks = val;
      this.taskFilterForm.pageOffset = val.number;
      this.paginationTasks = [{ pageNumber: val.number, className: 'page-item active' }];
    });
  }

  changePage(page: any): void {
    this.searchTasks(this.taskFilterForm.status, page.pageNumber);
  }

  previousPage(): void {
    let pageOffset = this.taskFilterForm.pageOffset === 0 ? 0 : this.taskFilterForm.pageOffset - 1;
    this.searchTasks(this.taskFilterForm.status, pageOffset)
  }

  nextPage(): void {
    let pageOffset = this.taskFilterForm.pageOffset === this.tasks.totalPages - 1
      ? this.taskFilterForm.pageOffset : this.taskFilterForm.pageOffset + 1;
    this.searchTasks(this.taskFilterForm.status, pageOffset);
  }

}
